<template>
  <div>
    <h1>Add Workflow</h1>
    <vue-form-generator
      :schema="buildSchema('workflow', 'workflowSchema', 'basicInfo', 'new')"
      :model="workflow"
      :options="formOptions" />
  </div>
</template>

<script>
import newForm from '@/mixins/new-form';

export default {
  name: 'admin-new-workflow',
  mixins: [newForm],

  data() {
    return {
      workflow: {
        colour: '#cc0000',
      },
      formName: 'Workflow',
      formParent: 'Company',
      formIndex: 'admin-workflows',
    };
  },
};
</script>
